import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric, IsNotEmpty, IsOptional, Matches, MaxLength } from "class-validator";

export class DeheadingPeelingDTO{
    @ApiProperty()
    @IsNotEmpty({message:"deheading peeling id should not be empty"})
    @IsAlphanumeric()
    deheadingpeelingId:number;


    @ApiProperty()
    @IsNotEmpty({message:"scopeOfWork should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    scopeOfWork:string;

    @ApiProperty()
    @IsNotEmpty({message:"grade should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    grade:string;

    @ApiProperty()
    @IsNotEmpty({message:"minGrade should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    minGrade:number;

    @ApiProperty()
    @IsNotEmpty({message:"maxGrade should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    maxGrade:number;

    @ApiProperty()
    @IsNotEmpty({message:"ratePerKg should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    ratePerKg:number;

    @ApiProperty()
    isActive:boolean;

    @ApiProperty()
    @IsOptional()
    @MaxLength(50,{message:"Created User allows maximum 50 characters"}) 
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })  
     createdUser: string | null;


    createdAt:Date;

  
    updatedAt: Date;

    @ApiProperty()
  @IsOptional()
  @MaxLength(50, { message: "Updated User allows maximum 50 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
    updatedUser: string | null;

  
    @ApiProperty()
    versionFlag : number;
  

}